import {getParameterByName} from '../modules/helpers/getParameter';

const tests = {
	paramMode: getParam
}

function getParam() {
	// if (location.hash == "#testing") {
	// 	document.querySelector('body').classList.add('testing');
	// 	return true;
	// }
	// if (location.hash == "#designmode") {
	// 	document.querySelector('body').classList.add('DesignMode');
	// 	return true;
  // }
  
  if (getParameterByName('testing')){
    document.querySelector('body').classList.add('testing');
    return true;
  }
  if (getParameterByName('designmode')){
    document.querySelector('body').classList.add('DesignMode');
    return true;
  }
  if (getParameterByName('font')){
    document.querySelector('body').classList.add('newFont');
    return true;
  }
  if (getParameterByName('debug')){
    document.querySelector('body').classList.add('debug');
    return true;
  }


	return false;

}

export default tests;
